<template>
    <div>
        <div
            class="fixed top-0 left-0 h-screen w-full bg-brand-neutral-7-50"
            @click="() => $emit('close')"
        ></div>
        <div
            class="w-screen rounded-t-xl bg-white fixed bottom-0 z-[200] left-0 md:w-96 md:left-1/2 md:-translate-x-1/2"
        >
            <div class="relative">
                <Button
                    class="absolute w-12 h-12 rounded-full top-4 left-4"
                    @click="() => $emit('close')"
                    variant="tertiary"
                >
                    <span
                        class="fi fi-sr-angle-small-down text-2xl flex"
                    ></span>
                </Button>
                <div
                    v-if="isReward"
                    class="absolute right-4 top-4 w-12 h-12 bg-brand-primary-1 text-brand-neutral-1 flex items-center justify-center rounded-full"
                >
                    <span class="fi fi-sr-gift flex text-2xl"></span>
                </div>
                <NuxtImg
                    class="h-64 w-full object-cover object-center rounded-t-xl"
                    :src="product.image"
                    :alt="product.name"
                />
                <div class="px-4 pt-4 pb-8">
                    <h1
                        class="text-brand-neutral-6-95 font-medium text-base mb-4"
                    >
                        {{ product.name }}
                    </h1>
                    <p class="text-brand-neutral-4 text-sm mb-6">
                        {{ product.description }}
                    </p>
                    <p
                        v-if="!isReward"
                        class="text-brand-neutral-7 text-xl font-bold mb-4"
                    >
                        {{ $utils.formatCurrency(product.price) }}
                    </p>
                    <p
                        :class="[
                            'font-bold mb-4',
                            isReward
                                ? 'text-brand-neutral-7 text-xl'
                                : 'text-brand-green-1 text-sm',
                        ]"
                    >
                        {{
                            isReward
                                ? `${$utils.formatPoints(
                                      product.points
                                  )} Pontos`
                                : `Ganhe + ${$utils.formatPoints(
                                      product.points
                                  )} Pontos`
                        }}
                    </p>
                    <Button href="/account/wallet">
                        <span class="fi fi-rs-QR text-2xl flex"></span>
                        Mostrar QR Code
                    </Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
const { product } = defineProps<{
    product: IProduct;
}>();

const isReward = product.type === ProductType.REWARD;

onMounted(() => {
    document.body.style.overflow = "hidden";
});

onUnmounted(() => {
    document.body.style.overflow = "";
});
</script>
